import { render, staticRenderFns } from "./copy.vue?vue&type=template&id=5284cc6c&scoped=true"
import script from "./copy.vue?vue&type=script&lang=js"
export * from "./copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5284cc6c",
  null
  
)

export default component.exports